var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-app-bar',{attrs:{"dense":"","app":"","scroll-threshold":"0"}},[_c('AppbarAccount')],1),_c('main',{staticClass:"v-main"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }